<div [@openCloseWithState]="showSearchSection ? 'open' : 'closed'">
	<form
		(ngSubmit)="searchByAddress(searchByAddressForm)"
		#searchByAddressForm="ngForm"
		class="items-center"
		id="teranetForm"
	>
		<div *ngIf="address?.street" class="flex flex-col gap-2 mr-10 mb-4">
			<span class="mr-2"> Quick Search of Address</span>

			<ui-button
				(click)="setAddress()"
				class="mr-2 inline"
				preset="MEDIUM_EMPHASIS"
				icon="search"
				[label]="address.street"
				[testHook]="testHooks.AddressStreetButton"
			>
			</ui-button>
		</div>
		<div class="flex pb-2">
			<div class="flex">
				<app-input
					label="Street number"
					name="streetNumber"
					[(ngModel)]="streetNumber"
					[testHook]="testHooks.StreetNumber"
				></app-input>
			</div>

			<div class="flex ml-5">
				<app-input
					label="Street name"
					name="streetName"
					[required]="true"
					[submitted]="submitted"
					[(ngModel)]="streetName"
					[testHook]="testHooks.StreetName"
				></app-input>
			</div>

			<div class="flex ml-5">
				<app-input
					label="Unit number"
					name="unitNumber"
					[(ngModel)]="unitNumber"
					[testHook]="testHooks.UnitNumber"
				></app-input>
			</div>

			<div class="flex items-end">
				<ui-button
					class="ml-5 mb-1"
					preset="HIGH_EMPHASIS"
					type="submit"
					teranetLoginGuard
					label="Search"
					[testHook]="testHooks.SearchButton"
				></ui-button>
			</div>
		</div>
	</form>
</div>

<app-pins-table
	[pins]="pins"
	[searching]="searchingPins"
	[error]="error"
	[isOverview]="isOverview"
	[name]="address?.street || streetNumber + ' ' + streetName"
></app-pins-table>
